import { temAcesso } from '@/shared/auth/temAcesso'

const Contratacoes = () => import('./Contratacoes.vue')
const Contratacao = () => import('./Contratacao.vue')
const Entrega = () => import('./../entregas/Entrega.vue')

export default {
    path: 'contratacoes',
    name: 'Gestores_Contratacoes',
    component: Contratacoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-GEST-CONT-00')) {
            next()
        }
    },
    children: [
        {
            path: ':contratacaoId',
            name: 'Gestores_Contratacoes_Detalhar',
            component: Contratacao,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CRED-GEST-CONT-01')) {
                    next()
                }
            },
            children: [
                {
                    path: 'entregas/:entregaId',
                    name: 'Gestores_Entregas_Detalhar2',
                    component: Entrega,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('CRED-GEST-ENTR-00')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
